import Link from "next/link";
import { getMonthName, formatEventType } from "@/lib/events";
import type { RowingEvent } from "@/types";

interface EventCalendarViewProps {
  events: RowingEvent[];
}

export function EventCalendarView({ events }: EventCalendarViewProps) {
  const eventsByMonth: Record<number, RowingEvent[]> = {};
  for (let m = 1; m <= 12; m++) {
    eventsByMonth[m] = events.filter((e) => e.month === m);
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
        <div
          key={month}
          className="rounded-lg border border-gray-200 dark:border-gray-700"
        >
          <div className="border-b border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800">
            <h3 className="font-semibold text-gray-900 dark:text-gray-100">
              {getMonthName(month)}
            </h3>
          </div>
          <div className="p-3">
            {eventsByMonth[month].length === 0 ? (
              <p className="text-sm text-gray-400 dark:text-gray-500">
                No events
              </p>
            ) : (
              <ul className="space-y-2">
                {eventsByMonth[month].map((event) => (
                  <li key={event.slug}>
                    <Link
                      href={`/events/${event.slug}`}
                      className="group block"
                    >
                      <span className="text-sm font-medium text-gray-900 group-hover:text-primary dark:text-gray-100">
                        {event.name}
                      </span>
                      <span className="mt-0.5 block text-xs text-gray-500 dark:text-gray-400">
                        {event.location.city} &middot;{" "}
                        {formatEventType(event.eventType)}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
